import { DelinquentRun } from '../../../react-admin/providers/handlers/TasksHandler';

// Renders an in-flight run's progress for the admin runs table:
//   "Generating… 10/100 (10%)" once the task has reported a total,
//   bare "Generating…" until a total is known (or when there are no candidates to scan).
// `Math.floor` keeps the percentage from showing 100% before the final report and never overshoots.
export const formatProgress = (run: Pick<DelinquentRun, 'processed' | 'total'>): string => {
  if (!run.total || run.total <= 0) {
    return 'Generating…';
  }
  // Clamp to [0, total] so an out-of-sync processed value (a stale/late write, or future change)
  // can never render a numerator above the total or a percentage above 100%.
  const processed = Math.max(0, Math.min(run.processed ?? 0, run.total));
  const pct = Math.floor((processed / run.total) * 100);
  return `Generating… ${processed}/${run.total} (${pct}%)`;
};
